var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"migrate-to-obk-flow"},[(_vm.currentStep)?_c(_vm.currentStep.component,_vm._b({tag:"component"},'component',_vm.currentStep.props,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }